const step_schema_generic = [
    // Vehicle
    {
        key: 'number_of_vehicles',
        value: 1
    },
    //policy
    {
        key: 'personal_miles',
        value: 3000,
    },
    {
        key: 'business_miles',
        value: 0,
    },
    // Drivers
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode',
        label: 'Postcode',
        placeholder: 'Postcode',
        type: 'text'
    },
    {
        key: 'has_criminal_convictions',
        label: 'Have you had any non-motoring convictions in the last 5 years?',
    },
    {
        key: 'has_driving_convictions'
    },
    {
        key: 'has_claims'
    },
    {
        key: 'cover_date'
    },
    {
        key: 'number_of_drivers'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_generic;
